/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { entryPointConfig, EntryPoint } from './entryPointConfig';
import { CampaignProvider } from './communication/CampaignContext';
import { TelemetryErrorBoundary } from './components/TelemetryErrorBoundary';

export { type EntryPoint, EntryPoints } from './entryPointConfig';



interface AppProps {
  entryPoint?: EntryPoint;
  adaptiveCardProps?: Record<string, unknown>;
}

export const AppContainer: React.FC<AppProps> = ({ entryPoint, adaptiveCardProps }) => {

  if (!entryPoint) {
    return null;
  }

  const Component = entryPointConfig[entryPoint] as React.ComponentType<any>;
  if (!Component) {
    return null;
  }

  const componentProps = entryPoint === 'adaptiveCards' ? adaptiveCardProps : undefined;

  return (
    <TelemetryErrorBoundary entryPoint={entryPoint}>
      <CampaignProvider>
        <Component {...componentProps} />
      </CampaignProvider>
    </TelemetryErrorBoundary>
  );
};
